import React from "react";
import "./AppsDropdown.css";
import { useNavigate, useLocation } from "../../hooks/useRouter";
import { useAccessibleApps } from "../../hooks/useAccessibleApps";
import { RBAC_APPS } from "../../constant/rbacConfig";

const APP_THEMES = {
    [RBAC_APPS.CHAT_GENIE]: { color: "yellow" },
    [RBAC_APPS.PROCUREMENT]: { color: "blue" },
    [RBAC_APPS.TRANSLATION]: { color: "purple" },
    [RBAC_APPS.GMT]: { color: "orange" },
    [RBAC_APPS.HR_ASSISTANT]: { color: "cyan" },
    [RBAC_APPS.DEEP_INSIGHTS]: { color: "orange" },
    [RBAC_APPS.TALENT_PULSE_360]: { color: "light-purple" },
    "user-management": { color: "gray" }
};

const AppsDropdown = ({ onClose }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { accessibleApps: visibleApps } = useAccessibleApps();

    return (
        <div className="apps-dropdown">
            <div className="apps-grid-container thin-scroll">
                {visibleApps.map((app) => {
                    const isActive = location.pathname.startsWith(app.path);
                    const theme = APP_THEMES[app.rbacKey] || APP_THEMES[app.id] || { color: "blue" };

                    return (
                        <div
                            key={app.id}
                            className={`app-item ${isActive ? "active" : ""}`}
                            onClick={() => {
                                navigate(app.path);
                                onClose?.();
                            }}
                        >
                            <div className={`app-icon theme-${theme.color}`}>
                                <img src={app.icon} alt={app.title} />
                            </div>
                            <span className="app-title">{app.title}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AppsDropdown;
